import React from "react";

import Hero from "../components/hero";
import ProjectSection from "../components/project-card-section";
import Journey from "../components/journey-section";

import profilePhoto from "../assets/profile-photo.png";
import cCIcon from "../assets/technologies/Adobe_Creative_Cloud_rainbow_icon.svg";
import illustratorIcon from "../assets/technologies/adobe-illustrator-icon.svg";
import photoshopIcon from "../assets/technologies/adobe-photoshop-icon.svg";
import inDesignIcon from "../assets/technologies/adobe-indesign-cc-icon.svg";
import premiereIcon from "../assets/technologies/premiere-pro-cc.svg";
import afterEffectsIcon from "../assets/technologies/after-effects-1.svg";
import canvaIcon from "../assets/technologies/canva-icon.svg";
import googleIcon from "../assets/technologies/google-analytics-4.svg";
import figmaIcon from "../assets/technologies/figma-icon.svg";
import xdIcon from "../assets/technologies/adobe-xd-icon.svg";
import wordpressIcon from "../assets/technologies/wordpress-icon.svg";
import wixIcon from "../assets/technologies/wix-svgrepo-com.svg";
import squarespaceIcon from "../assets/technologies/squarespace-svgrepo-com.svg";
import finalCutIcon from "../assets/technologies/icons8-final-cut-pro-x.svg";
import daVinciIcon from "../assets/technologies/davinci-resolve-12.svg";
import logicIcon from "../assets/technologies/icons8-logic-pro-x.svg";
import proToolsIcon from "../assets/technologies/logo-protools-svgrepo-com.svg";


const Home: React.FC = () => {

  return (
    <div className="mb-24">
      <Hero />

      <h2 className="font-euro text-white text-center text-3xl mt-10 mb-3">Projects</h2>
      <div className="border-t-2 border-orange mx-16"></div>
      <ProjectSection />

      <h2 className="font-euro text-white text-center text-3xl mt-10 mb-3">About</h2>
      <div className="border-t-2 border-orange mx-16"></div>

      <div className="mx-10 md:mx-20 mt-10">
      <div className="block md:grid md:grid-cols-3 md:gap-8 items-start my-20">
        {/* Profile Photo and Box One */}
        <div className="relative">
          {/* Box One */}
          <div className="absolute w-60 h-60 border-4 border-orange -top-4 -left-4"></div>
          {/* Profile Photo */}
          <img className="relative w-60 h-60 object-cover transition-transform duration-300 ease-in-out transform hover:rotate-6" src={profilePhoto} alt="Luke Archer" />
        </div>

        {/* Quote Block and Box Two */}
        <div className="relative col-span-2">
          {/* Box Two */}
          <div className="absolute w-full h-48 border-4 border-orange -bottom-4 -left-6"></div>
          {/* Quote Block */}
          <blockquote className="relative text-xl md:text-2xl font-euro text-white bg-darkGray p-6 md:p-8">
            <svg
              className="w-8 h-8 text-white mb-4"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 18 14"
            >
              <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
            </svg>
            <p className="transition-transform duration-300 ease-in-out transform hover:rotate-3">Design isn’t just what I do - it’s how I communicate, connect, and bring ideas to life.</p>
          </blockquote>
        </div>
      </div>

      <div className="border-4 border-orange p-5 md:p-8">
      <h3 className="text-white font-euro text-2xl mb-4">Technologies</h3>

      <div className="flex flex-wrap">
        <div className="group relative">
          <img
            src={cCIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Adobe Creative Cloud</span
          >
        </div>
        <div className="group relative">
          <img
            src={canvaIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Canva</span
          >
        </div>
        <div className="group relative">
          <img
            src={illustratorIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Illustrator</span
          >
        </div>
        <div className="group relative">
          <img
            src={photoshopIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Photoshop</span
          >
        </div>
        <div className="group relative">
          <img
            src={inDesignIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >InDesign</span
          >
        </div>
        <div className="group relative">
          <img
            src={premiereIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Premiere Pro</span
          >
        </div>
        <div className="group relative">
          <img
            src={afterEffectsIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >After Effects</span
          >
        </div>
        <div className="group relative">
          <img
            src={xdIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Xd</span
          >
        </div>
        <div className="group relative">
          <img
            src={figmaIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Figma</span
          >
        </div>
        <div className="group relative">
          <img
            src={googleIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Google Analytics</span
          >
        </div>
        <div className="group relative">
          <img
            src={wordpressIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >WordPress</span
          >
        </div>
        <div className="group relative">
          <img
            src={wixIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Wix</span
          >
        </div>
        <div className="group relative">
          <img
            src={squarespaceIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Squarespace</span
          >
        </div>
        <div className="group relative">
          <img
            src={finalCutIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Final Cut Pro</span
          >
        </div>
        <div className="group relative">
          <img
            src={daVinciIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Da Vinci</span
          >
        </div>
        <div className="group relative">
          <img
            src={logicIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >Logic Pro X</span
          >
        </div>
        <div className="group relative">
          <img
            src={proToolsIcon}
            alt="Technology Icon"
            className="w-14 h-14 m-4"
          />
          <span
            className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
            >ProTools</span
          >
        </div>
      </div>
      </div>

      <Journey />

        <h3 className="text-white font-euro text-2xl mb-4">Skills</h3>

        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Creativity
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Branding
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Print Collatoral
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Project Management
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          UI/UX Design
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Social Media
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Analytics
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Copywriting
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Typography
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Colour Theory
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Layout
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Composition
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Leadership
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Video Editing
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Animation
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Communication
        </p>
        <p
          className="inline-block bg-orange font-frank text-white text-xl px-4 py-1 my-1 mx-2 transition-transform duration-300 ease-in-out transform hover:rotate-6"
        >
          Adaptability
        </p>
      </div>
    </div>
  );
};

export default Home;
